import { MetricsScene, ContextParams } from './types';
import { match } from './utils';

/**
 * 度量视图 path
 */
const METRICS_VIEW_PATH = '/:project/workObjectView/chart/:viewId';

/**
 * 可能为视图-度量模式的工作项视图 path
 */
const VIEW_MEASURE_MODE_PATH = [
  // 需求视图
  `/:project/storyView/:viewId`,
  // 缺陷视图
  `/:project/issueView/:viewId`,
  // 全景视图
  `/:project/multiProjectView/:viewId`,
];

// 自定义工作项视图
const CUSTOM_VIEW_MEASURE_MODE_PATH = '/:project/workObjectView/:apiName/:viewId';

function isMetricsSceneByPageServer() {
  const { scene } = window.matchScene?.metrics || {};
  if (!scene) {
    return false;
  }
  return [MetricsScene.VIEW_MEASURE_MODE, MetricsScene.METRICS_VIEW].includes(scene);
}

function initSceneContext(scene: MetricsScene, params: ContextParams) {
  const { viewId, project } = params || {};
  window.syncMetricsMatchScene = {
    scene,
    context: {
      projectSimpleName: project,
      viewId,
    },
  };
}

export function syncCheckMetricsScene() {
  try {
    const { pathname } = window.location;
    const pathRegExp = match(METRICS_VIEW_PATH);
    const metricsViewRegRes = pathRegExp(pathname);

    if (metricsViewRegRes) {
      initSceneContext(MetricsScene.METRICS_VIEW, metricsViewRegRes.params as ContextParams);
      return true;
    }
    const isViewModePath = VIEW_MEASURE_MODE_PATH.reduce(
      (res, path) => res || match(path)(pathname),
      null,
    );
    const isCustomView = match(CUSTOM_VIEW_MEASURE_MODE_PATH)(pathname);
    const hit = isCustomView || isViewModePath;
    const hasChart = new URLSearchParams(window.location.search).get('viewMode') === 'chart';
    if (hit && hasChart) {
      initSceneContext(MetricsScene.VIEW_MEASURE_MODE, hit.params as ContextParams);
      return true;
    }

    if (isMetricsSceneByPageServer()) {
      const { context, scene } = window.matchScene?.metrics || {};
      if (scene && context) {
        return true;
      }
    }

    return false;
  } catch (error) {
    return false;
  }
}

const STREAM_METRIC_EVENT = 'MATCH_METRICS_SCENE_END';

export async function asyncCheckMetricsScene(checkSuccessCallback?: () => void): Promise<boolean> {
  return new Promise(resolve => {
    if (!window?.streamService?.onCustomEvent) {
      return resolve(false);
    }

    let resolved = false;
    let timeoutId: ReturnType<typeof setTimeout> | null = null;

    const matchSceneCallback = () => {
      if (resolved) {
        return;
      }
      resolved = true;
      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      if (isMetricsSceneByPageServer()) {
        const { context, scene } = window.matchScene?.metrics || {};
        if (scene && context) {
          checkSuccessCallback?.();
          resolve(true);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    };

    window.streamService.onCustomEvent(STREAM_METRIC_EVENT, matchSceneCallback);

    timeoutId = setTimeout(() => {
      if (resolved) {
        return;
      }
      resolved = true;
      resolve(false);
    }, 3000);
  });
}
